import React, { useMemo } from 'react';
import { useListNonPagedDepartmentQuery } from 'hooks/queries';
import { useTranslation } from 'react-i18next';
import { ALL } from 'litterals';

const useDepartmentList = (options) => {
  const { data: departmentList, isLoading } = useListNonPagedDepartmentQuery({
    ...options,
  });

  const { t } = useTranslation();

  //We add a specific translation map for CCIFS company (See ccifs.json translation file)
  const translationsCCIFSMap = {
    'Oui, je suis membre de la chambre': 'departmentsOptions.chamberMemberYes',
    'Non, je ne suis pas membre de la chambre': 'departmentsOptions.chamberMemberNo',
  };
  const departmentOption = useMemo(() => {
    if (!departmentList) return [];
    const formattedDepartments = departmentList.map((department) => {
      const translationKey = translationsCCIFSMap[department.name];
      const displayName = translationKey ? t(translationKey) : department.name;
      return {
        value: department.id,
        label: displayName,
      };
    });

    // Ajoutez simplement l'élément supplémentaire à la fin de la liste
    return formattedDepartments.concat({ value: '', label: t(ALL) });
  }, [departmentList, t]);
  const simpleDepartmentOption = useMemo(
    () =>
      departmentList?.map((department) => {
        const translationKey = translationsCCIFSMap[department.name];
        const displayName = translationKey ? t(translationKey) : department.name;
        return {
          value: department.id,
          label: displayName,
        };
      }) || [],
    [departmentList]
  );

  return {
    departmentOption,
    simpleDepartmentOption,
    isLoading,
  };
};

export default useDepartmentList;
